import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
    en: {
        welcome: {
            register: 'REGISTER',
            login: 'LOGIN',
            logout: 'LOGOUT',
            guide: 'Guide',
            support: 'Support',
            plans: 'Plans',
            policy: 'Policy',
            privacy: 'Privacy',
            commercial_terms: 'Commercial Terms',
            notice: 'Notice',
        },
        account_modal: {
            account: 'Account',
            report_an_issue: 'Report an Issue',
            my_requests: 'My Requests',
            user_guide: 'User Guide',
            what_s_new_in_bt: "What's new in BT",
            notice: 'Notice',
            sign_out: 'Sign Out',
            to: 'To {0}',
            admin: 'Admin',
            trial: 'Premium(trial)',
            expired: 'Expired',
            lifetime: 'Premium(lifetime)',
            premium: 'Premium',
            basic: 'Basic',
            event: 'Premium(event)',
            subscribe: 'Premium subscription',
        },
        change_name: {
            change_name: 'Change your name',
            firstname: 'Firstname',
            lastname: 'Lastname',
            try_again: 'Please try again.',
            close: 'Close',
            confirm: 'Confirm',
        },
        change_password: {
            change_password: 'Change your password',
            password: 'Password',
            password_re: 'Confirm',
            close: 'Close',
            confirm: 'Confirm',
            try_again: 'Please try again.'
        },
        change_profile: {
            change_profile: 'Change profile photo',
            change_photo: 'Change photo',
            remove_photo: 'Remove photo',
            upload_photo: 'Upload photo',
            close: 'Close',
        },
        change_email: {
            change_email: 'Change Email',
            resend_email: 'Resend Email',
            confirm_email_text: "You can't reset your password if you forgot your password before email verification. You cannot change your email after the verification.",
            success: 'The email has been resent successfully',
            success_text: 'Please check your mailbox.'
        },
        header: {
            gallery: 'Gallery',
            lab: 'Lab',
            document_clip: 'Document Clip',
            reviews: 'Reviews',
            account: 'Account',
            my_projects: 'My Projects',
            my_requests: 'My Requests',
        },
        account: {
            profile: 'PROFILE',
            membership: 'MEMBERSHIP',
            plan_details: 'PLAN DETAILS',
            settings: 'SETTINGS',
            name: 'Name',
            password: 'Password',
            start_date: 'Start date',
            language: 'Language',
            manage_profile_photo: 'Manage Profile Photo',
            change_name: 'Change Name',
            change_password: 'Change Password',
            change: 'Change',
            billing_details: 'Billing Details',
            premium: 'Premium',
            monthly: 'Monthly',
            won: 'Won',
            next_payment_date: 'Next payment date',
            cancel_premium: 'Cancel premium',
            type: 'Type',
            date: 'Date',
            product_name: 'Product name',
            payment_method: 'Payment method',
            payment_amount: 'Payment amount',
            payment_status: 'Payment status',
            requested: 'Requested',
            completed: 'Completed',
            failed: 'Failed',
            canceled: 'Canceled',
            refunded: 'Refunded',
            cashwait: 'Wait',
            back_to_lab: 'Lab',
            update_payment_info: 'Update payment information',
            alert_update_payment_info: 'Please update your payment information!',
            alert_update_payment_error: 'An error occurred while updating payment information.',
            current_payment_methods: 'Current payment methods',
            alert_update_payment_1: 'Please select a payment method below to update your payment information.',
            alert_update_payment_2: 'If the pop-up window does not appear, please allow the pop-up in your browser.',
        },
        login: {
            username: 'Username',
            password: 'Password',
            remember_me: 'Remember me',
            email: 'Email',
            login: 'Login',
            register: 'Register',
            forgot_password: 'Forgot Password',
            password_reset: 'Password Reset',
            password_reset_subtitle: 'we’ll send you the link to reset your password.',
            forgot_email: 'Forgot Email?',
            back_to_login: 'Back to login',
            check_mailbox: 'Please check your mailbox',
            check_mailbox_subtitle: "We've sent an email to { 0 }. If you don't see the email, check other places like your spam folders.",
            forgot_email_subtitle: "Search every email account you use for 'BiblioTrees' to find any emails we have sent you. If you can't find it, please click the contact button below.",
            contact: 'Contact',
        },
        register: {
            username: 'Username',
            firstname: 'Firstname',
            lastname: 'Lastname',
            email: 'Email',
            password: 'Password',
            password_re: 'Re-enter password',
            try_again: 'Please try again',
            required: 'This field is required',
            login: 'Login',
            register: 'Register',
            home: 'Home',
            alert: 'The confirmation email has been sent. Please check your mailbox.',
            go_home: 'Go Home',
            username_not_valid: 'Username must contain 6-30 characters and you can use letters, numbers and periods',
            username_not_available: 'This username is not available',
            password_not_valid: 'Password must contain 8-30 characters with at least one letter, and one number',
            password_not_same: "Those passwords didn't match.",
            trial_30: 'Start your premium 30-day trial!',
            start_trial: 'Start your premium trial',
            agree_description: 'By creating an account, you are agreeing to our <a href="/policy" target="_blank">Terms of Service</a> and <a href="/privacy" target="_blank">Privacy Policy</a>.',
            trial_text: 'The one-month premium trial is started right now!',
            no_card: 'No credit card required',
        },
        signup: {
            register: 'Register',
            register_text: 'Create your account',
            plan_selection: 'Plan Selection',
            plan_selection_text: 'Choose your plan',
            payment: 'Payment',
        },
        lab: {
            document: 'Document',
            start_project: 'Start New Project',
            activate_projects: 'Activate Projects',
            working_project: 'Working',
            complete_project: 'Complete',
            holding_project: 'Holding',
            preparing_project: 'Preparing',
            read_only_project: 'Read-only',
            working: 'Working',
            complete: 'Complete',
            holding: 'Holding',
            preparing: 'Preparing',
            lab: 'Lab',
            document_clip: 'Document clip',
            projects: 'My projects',
            my_reviews: 'My Reviews',
            watching_projects: 'Watch',
            library: 'Library',
            status: 'Status',
            title: 'Title',
            note_words: 'Note Words',
            note_modified: 'Note Modified',
            created: 'Created',
            completed: 'Completed',
            visited: 'Visited',
            start: 'Start',
            close: 'Close',
            words: 'words',
            modified: 'Modified',
            empty_subtitle: "It's your own research space, 'LAB'",
            empty_title: 'Create your project',
            project_info_1: 'A project is a unit that collects and manages documents.',
            project_info_2: 'You can create a project for each topic of interest, such as writing a report or article.',
            open_soon: 'Open Soon!',
        },
        document_clip: {
            copy_move_to_projects: 'Copy/move to projects',
            remove_from_document_clip: 'Remove from document clip',
        },
        reviews: {
            my_reviews: 'My Reviews',
            type: 'Type',
            authors: 'Authors',
            year: 'Year',
            title: 'Title',
            modified: 'Modified',
            document_details: 'Document Details',
            close: 'Close',
            project: 'Project',
            empty_title: '📝 Here is the review page.',
            empty_subtitle_1: 'You can gather reviews of the documents you added to each project.',
            empty_subtitle_2: 'Write a review on your project document!'
        },
        create_project: {
            start_project: 'Start New Project',
            title: 'Title',
            description: 'Description',
            view_mode: 'View Mode',
            tree: 'Tree',
            note: 'Note',
            cancel: 'Cancel',
            start_later: 'Start later',
            start_now: 'Start now',
            required: 'This field is required',
            available: 'This title is not available',
        },
        update_project: {
            update_project: 'Update Project',
            title: 'Title',
            description: 'Description',
            status: 'Status',
            working: 'Working',
            complete: 'Complete',
            holding: 'Holding',
            preparing: 'Preparing',
            view_mode: 'View Mode',
            tree: 'Tree',
            note: 'Note',
            upload_photo: 'Upload Photo',
            change_photo: 'Change Photo',
            remove_photo: 'Remove Photo',
            delete_project: 'Delete Project',
            required: 'This field is required',
            available: 'This title is not available',
            close: 'close',
            save: 'save',
            delete_project_description: 'Are you sure you want to delete project "{0}"? You cannot recover deleted projects.'
        },
        project: {
            note: 'NOTE',
            tree: 'TREE',
            update_project: 'Update project',
            reload: 'Reload the tree',
            show_suggestions: 'Show suggestions',
            close_suggestions: 'Close suggestions',
            project: 'Project',
            in_project: 'in my project',
            not_in_project: 'not in my project',
            refer: 'Refer',
            translate: 'Translate',
            revise: 'Revise',
            contents: 'Contents',
            read_only: 'Read-only',
        },
        proj_note: {
            not_loaded: 'Note is not loaded',
            not_loaded_description: 'An error occured while loading your notes. Please reload.',
            draft_not_saved: 'Draft is not saved',
            draft_not_saved_description: 'An error occurred while synchronizing your drafts. Please reload.',
            not_storable: 'Your storage has been exceeded. The added content is not saved.',
            reload: 'Reload',
            note_not_saved: 'Note is not saved',
            note_not_saved_description: 'An error occurred while synchronizing your notes. Please reload.',
            note_crashed: 'Notes crashed while saving.',
            note_crashed_description: 'Notes crashed while saving. Please check your notes.',
            confirm: 'Confirm',
            cancel_note: 'Are you sure you want to cancel saving your notes? Your notes will be modified to the following:',
            change_not_saved: 'There are unsaved changes',
            all_changes_saved: 'All changes saved',
            draft_error: 'Draft saving error',
            save_error: 'Note saving error',
            saving_draft: 'Saving draft...',
            draft_is_saved: 'Draft is saved',
            last_modified: 'Last modified: ',
            storage: 'Storage: ',
            save: 'Save',
            cancel: 'Cancel',
        },
        doc_list: {
            documents: 'Documents',
            add_documents: 'Add Documents',
            in_project: 'IN PROJECT',
            in_tree: 'IN TREE',
            in_suggestion: 'IN SUGGESTION',
            card_view: 'Card view',
            list_view: 'List view',
            open_all_reviews: 'Open all reviews',
            close_all_reviews: 'Close all reviews',
            tags: 'Tags',
            edit_documents: 'Edit Document List',
            remove_documents: 'Remove Documents',
            copy_move: 'Copy/Move',
            remove: 'Remove',
            done: 'Done',
            references: 'references',
            review: 'Review',
            add_documents: 'Add documents',
            empty_title: 'Press the button below to add a new document.',
            empty_meta_1: "You can enter information directly in the pop-up window, or add documents through the 'Upload files' button at the top of the pop-up window.",
            empty_meta_2: "Check your project note and tree through the 'Note' and 'Tree' tabs on the top left.",
        },
        add_documents: {
            add_documents: 'Add Documents',
            add_references: 'Add References',
            add_doc_successfully: 'Add document successfully',
            add_ref_successfully: 'Add reference successfully',
            add_documents_to_document_clip: 'Add documents to CLIP',
            reload: 'Reload',
            type: 'Type',
            not_recorded: 'Not recorded',
            et_al: 'et al.',
            more: 'more',
            less: 'less',
            close: 'Close',
            add: 'Add',
            see_document: 'See document',
            add_others: 'Add others',
            already: 'Already in the project',
            improve: 'Improve the document info!',
            fill: 'Fill in the blanks',
            fill_required: 'Please fill in the required fields.',
            confirm: 'Confirm',
            error_fileform: 'An error has occured checking file forms',
            error_checking: 'An error has occured checking documents',
            error_inputting: 'An error has occured inputting documents',
            error_preview: 'An error has occured receiving new documents',
            suggestions: 'Suggestions',
            search: 'Search',
            manual: 'Input manually',
            upload: 'Upload files',
        },
        import_files: {
            import_files: 'Import Files',
            files: 'files',
            documents: 'documents',
            duplicates: 'duplicates',
            prepare: 'Prepare',
            check: 'Check',
            upload: 'Upload',
            stop: 'Stop',
            select_all: 'Select all',
            document_list: 'Document list',
            already_in_project: 'Already in the project',
            already_in_cliip: 'Already in the clip',
            already_in_document: 'Already in the document',
            improve: 'Improve the document info!',
            right_info: 'What is the right information?',
            add_to_project: 'Add to project',
            add_to_document: 'Add to document',
        },
        improve_doc_info: {
            right_information: 'What is the right information?',
            existing_columns: 'Existing columns',
            new_columns: 'New columns',
            compare_columns: 'Compare columns',
        },
        gallery: {
            all: 'All',
            theme: 'Theme',
            person: 'Person',
            document: 'Document',
            coming_soon: 'This category is coming soon.',
            picture_not_prepared: 'A picture is not prepared',
            category: 'Category',
            title: 'Title',
            tags: 'Tags',
            like: 'Like',
            my_like: 'My like',
        },
        mp: {
            reload: 'Reload the tree',
            masterpiece: 'Masterpiece',
            in_masterpiece: 'in my masterpiece',
            not_in_masterpiece: 'not in my masterpiece'
        },
        mp_list: {
            documents: 'Documents',
            in_masterpiece: 'IN MASTERPIECE',
            in_tree: 'IN TREE',
            like_document: 'Like this document',
            fork_document: 'Fork this document',
            google_scholar: 'Google Scholar',
        },
        fork_mp: {
            fork_masterpiece: 'Fork masterpiece',
            title: 'Title',
            description: 'Description',
            view_mode: 'View mode',
            tree: 'Tree',
            note: 'Note',
            close: 'Close',
            fork: 'Fork',
            like: 'Like',
            complete: 'This masterpiece has been fork into your lab.',
            go_project: 'Go to project',
            required: 'This field is required',
            title_not_available: 'This title is not available',
        },
        fork_doc: {
            fork_document: 'Fork document',
            select_project: 'Select a project',
            close: 'Close',
            fork: 'Fork',
            complete: 'The document has been fork into your project.',
            go_project: 'Go to project',
            already: 'This document is already in the project.',
        },
        sorting: {
            title_a: 'Title: A to Z',
            title_d: 'Title: Z to A',
            date_a: 'Date: Most to least recent',
            date_d: 'Date: Least to most recent',
            created_date_a: 'Created: Most to least recent',
            created_date_d: 'Created: Least to most recent',
            visited_date_a: 'Visited: Most to least recent',
            visited_date_d: 'Visited: Least to most recent',
            modified_date_a: 'Modified: Most to least recent',
            modified_date_d: 'Modified: Least to most recent',
            author_a: 'Author: A to Z',
            author_d: 'Author: Z to A',
            title: 'Title',
            date: 'Date',
            created_date: 'Date Created',
            visited_date: 'Date Visited',
            author: 'Author',
        },
        doc_types: {
            book: 'Book',
            book_chapter: 'Book Chapter',
            journal: 'Journal',
            journal_article: 'Journal Article',
            conference: 'Conference',
            conference_paper: 'Conference Paper',
            thesis: 'Thesis',
            thesis_chapter: 'Thesis Chapter',
            gov_document: 'Government Document',
            gov_document_article: 'Government Document Article',
            law: 'Law',
            law_article: 'Law Article',
            statistics: 'Statistics',
            statistics_table: 'Statistics Table',
            newspaper: 'Newspaper',
            newspaper_article: 'Newspaper Article',
            magazine: 'Magazine',
            magazine_article: 'Magazine Article',
            music_album: 'Music Album',
            music: 'Music',
            film: 'Film',
            film_episode: 'Film Episode',
            map: 'Map',
            etc: 'Etc',
        },
        doc_info: {
            index: 'Index',
            title: 'Title',
            authors: 'Authors',
            author: 'Author',
            editor: 'Editor',
            translator: 'Translator',
            date: 'Date',
            abstract: 'Abstract',
            publication: 'Publication',
            publisher: 'Publisher',
            references: 'References',
            note: 'Note',
            star: 'Star',
            tag: 'Tag',
            doc_type: 'Document Type',
            list: 'List',
            go_list: 'Go to document list',
            add: 'Add',
            add_to: 'Add document to this project',
            remove: 'Remove',
            remove_from: 'Remove document from this project',
            pre: 'Pre',
            pre_doc: 'Previous document',
            next: 'Next',
            next_doc: 'Next document',
            report: 'Report an issue',
            my_review: 'My Review',
            add_review: 'Add my review',
            add_references: 'Add references',
            more: 'more',
            less: 'less',
            related_resources: 'Related resources',
            contents: 'Contents',
            other_editions: 'Other editions',
            original_text: 'Original text',
            translations: 'Translations',
            referred_by: 'Referred by',
            report_url: 'Report URL',
            add_url: 'Add URL',
            report_url_text: 'Is the URL wrong? Please report it and it will be corrected by administrator.',
            add_url_text_1: 'Please report URL and it will be added by administrator.',
            add_url_text_2: 'If you have multiple URLs, please separate them with Enter button.',
        },
        input_form: {
            doc_type: 'Document Type',
            author: 'Author',
            reporter: 'Reporter',
            creator: 'Creator',
            director: 'Director',
            maker: 'Maker',
            authors: 'Authors',
            reporters: 'Reporters',
            directors: 'Directors',
            makers: 'Makers',
            date: 'Date',
            statistics_date: 'Statistics Date',
            address_date: 'Address Date',
            publishing_date: 'Publishing Date',
            conference_dates: 'Conference Dates',
            year: 'Year',
            title: 'Title',
            law_title: 'Law Title',
            statistics_title: 'Statistics Title',
            issue_title: 'Issue Title',
            article_title: 'Article Title',
            album_title: 'Album Title',
            film_title: 'Film Title',
            chapter_title: 'Chapter Title',
            table_title: 'Table Title',
            music_title: 'Music Title',
            episode_title: 'Episode Title',
            subtitle: 'Title',
            language: 'Language',
            lang: 'Language',
            contents: 'Contents',
            description: 'Description',
            abstract: 'Abstract',
            keyword: 'Keyword',
            keywords: 'Keywords',
            doi: 'DOI',
            chapter_doi: 'Chapter DOI',
            article_doi: 'Article DOI',
            paper_doi: 'Paper DOI',
            book_doi: 'Book DOI',
            thesis_doi: 'Thesis DOI',
            document_doi: 'Document DOI',
            proceeding_doi: 'Proceeding DOI',
            publication_doi: 'Publication DOI',
            DOI: 'DOI',
            DOI_chapter: 'Chapter DOI',
            DOI_article: 'Article DOI',
            DOI_paper: 'Paper DOI',
            DOI_book: 'Book DOI',
            DOI_thesis: 'Thesis DOI',
            DOI_document: 'Document DOI',
            DOI_proceeding: 'Proceeding DOI',
            DOI_publication: 'Publication DOI',
            url: 'URL',
            chapter_url: 'Chapter URL',
            article_url: 'Article URL',
            table_url: 'Table URL',
            music_url: 'Music URL',
            episode_url: 'Episode URL',
            map_url: 'Map URL',
            book_url: 'Book URL',
            thesis_url: 'Thesis URL',
            report_url: 'Report URL',
            law_url: 'Law URL',
            statistics_url: 'Statistics URL',
            journal_url: 'Journal URL',
            conference_url: 'Conference URL',
            newspaper_url: 'Newspaper URL',
            magazine_url: 'Magazine URL',
            album_url: 'Album URL',
            film_url: 'Film URL',
            publication_url: 'Publication URL',
            URL: 'URL',
            URL_chapter: 'Chapter URL',
            URL_article: 'Article URL',
            URL_table: 'Table URL',
            URL_music: 'Music URL',
            URL_episode: 'Episode URL',
            URL_map: 'Map URL',
            URL_book: 'Book URL',
            URL_thesis: 'Thesis URL',
            URL_report: 'Report URL',
            URL_law: 'Law URL',
            URL_statistics: 'Statistics URL',
            URL_journal: 'Journal URL',
            URL_conference: 'Conference URL',
            URL_newspaper: 'Newspaper URL',
            URL_magazine: 'Magazine URL',
            URL_album: 'Album URL',
            URL_film: 'Film URL',
            URL_publication: 'Publication URL',
            journal_name: 'Journal Name',
            conference_name: 'Conference Name',
            newspaper_name: 'Newspaper Name',
            magazine_name: 'Magazine Name',
            book_title: 'Book Title',
            document_title: 'Document Title',
            map_title: 'Atlas Title',
            publication_title: 'Publication Title',
            volume: 'Volume',
            volume_issue: 'Volume(Issue)',
            number: 'Number',
            numberth: 'Numberth',
            pages: 'Pages',
            article_number: 'Article Number',
            episode_number: 'Episode Number',
            edition: 'Edition',
            diplome_title: 'Diplome Title',
            document_category: 'Document Category',
            version: 'Version',
            provisional_confirmed: 'Provisional / Confirmed',
            session: 'Session',
            morning_afternoon: 'Morning / Afternoon',
            map_size: 'Map Size',
            publisher: 'Publisher',
            university: 'University',
            institution: 'Institution',
            company: 'Company',
            label: 'Label',
            production: 'Production',
            oclc: 'OCLC',
            OCLC: 'OCLC',
            isbn: 'ISBN',
            ISBN: 'ISBN',
            issn: 'ISSN',
            ISSN: 'ISSN',
            editor: 'Editor',
            editors: 'Editors',
            jury: 'Jury',
            juries: 'Juries',
            translator: 'Translator',
            translators: 'Translators',
            paper_ebook: 'Paper E-Book',
            department: 'Department',
            law_category: 'Law Category',
            online_paper: 'Online Paper',
            place: 'Place',
            dvd_online: 'DVD / Online',
            note: 'Note',
            other_idf: 'Other Identification',
            digital_paper: 'Digital Paper',
            film_note: 'Film Note',
        },
        issues: {
            id: 'Id',
            type: 'Type',
            title: 'Title',
            created: 'Created',
            status: 'Status',
            detail: 'Detail',
            document: 'Document',
            authentication: 'Authentication',
            purchase: 'Purchase',
            error: 'Error',
            etc: 'Etc',
            new: 'Open',
            in_progress: 'Received',
            reporter_action: 'Awaiting your reply',
            solution_provided: 'Answer complete',
            closed: 'Closed',
            reported_on: 'reported on',
            commented_on: 'commented on',
            add_a_comment: 'Add a comment',
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            go_back: 'Go back',
            in_progress_info: 'We need more information to solve your issue. Press details button and leave a reply.',
            solution_provided_info: 'A solution is provided. Press details button to leave a reply or close your request.',
            check_my_issue: 'Check my issue',
            continue: 'Continue',
            issue_close: 'Close this report',
            solved: 'Solved',
            close_request: 'Close my request',
            close_alert: 'This request will be closed permanently.',
            report_issue: 'Report an Issue',
            what_kind: 'What kind of issue?',
            description: 'Description',
            document_details: 'Document Details',
            related_documents: 'Related Documents',
            references: 'References',
            other_issue: 'Other Issue',
            write_down: 'Please write down the issue in detail',
            success: 'Add your issue successfully',
            try_again: 'Please try again',
            empty_title: '🙋 Here is the issue page.',
            empty_subtitle: 'Do you have any questions about BilbioTrees?',
            send_feedback: 'Send Feedback',
            success_text: 'We will notify you by email as soon as your issue is checked.',
        },
        lang: {
            id: 'Indonesian',
            ms: 'Malay',
            da: 'Danish',
            de: 'German',
            en: 'English',
            es: 'Spanish',
            fr: 'French',
            it: 'Italian',
            nl: 'Dutch',
            pl: 'Polish',
            pt: 'Portuguese',
            fi: 'Finnish',
            sv: 'Swedish',
            vi: 'Vietnamese',
            tr: 'Turkish',
            ru: 'Russian',
            ar: 'Arabic',
            th: 'Thai',
            ko: 'Korean',
            zh: 'Chinese',
            ja: 'Japanese',
            xx: 'Not recorded',
        },
        alert: {
            try_again: 'Please try again',
            required: 'This field is required',
            email_not_valid: 'Enter an valid email address (id@company.com)',
            email_not_available: 'This email is not available.',
        },
        actions: {
            submit: 'Submit',
            save: 'Save',
            retry: 'Retry',
            next: 'Next',
            confirm: 'Confirm',
            cancel: 'Cancel',
            delete: 'Delete',
            close: 'Close',
            go_back_to_lab: 'Go back to my lab',
            skip: 'Skip',
            select_all: 'Select all',
        },
        note: {
            not_saved: 'Not saved',
            last_modified: 'Last modified',
            storage: 'Storage',
            delete: 'Delete',
            export: 'Export',
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            continue: 'Continue',
            delete_review: 'Delete Review',
            delete_alert: 'This review will be removed permanently.',
        },
        plans: {
            TRIAL_90_DAYS: '90-DAY TRIAL',
            TRIAL_30_DAYS: '30-DAY TRIAL',
            event_2021: '2021 Re-start Event',
            one_month_event: '1-MONTH',
            PLAN_1_YEAR: 'PLAN 1-YEAR',
            LIFETIME: 'LIFETIME membership',
            EVENT_PLAN_1_YEAR: '[EVENT] PLAN 1-YEAR',
            PLAN_LIFETIME: 'LIFETIME membership',
            EVENT_LIFETIME: '[EVENT] LIFETIME membership',
            price_unit: '$ {0}',
            price_KRW: '₩ {0}',
            price_USD: '$ {0}',
            month: ' /month',
            billed_as: 'Billed as one payment of ${0}',
            payment_currency: 'Currency',
            KRW: 'Account transfer',
            USD: 'Paypal',
            card: 'Credit card',
            phone: 'Phone',
            discount: 'discount',
        },
        payment: {
            enter_payment_details: 'Enter payment details',
            start_free_trial: 'Would you start free premium trial?',
            payment_methods: 'Payment methods',
            depositor_name: 'Depositor name',
            cash_receipt: 'Do you need a cash receipt?',
            receipt_yes: 'Yes',
            receipt_no: 'No',
            KRW: 'Account transfer (Korean account)',
            USD: 'Paypal (Korean account is not available)',
            phone: 'Phone number',
            id: 'Resident registration number',
            card: 'Cash receipt card number',
            no_card_required: 'No credit card required',
            payment_summary: 'Membership Summary',
            trial_30days: '30days premium trial',
            three_months: '3 months',
            twelve_months: '12 months',
            purchase: 'Start Membership',
            agree_start: 'Agree and get started',
            complete_the_deposit: 'Please complete the deposit',
            deposit_text: 'Please deposit ${0} to the account below and enter the confirm button.',
            account_number: 'Account number',
            welcome: 'Welcome!',
            with_bt: 'Start a fun and convenient research with BiblioTrees.',
            go_to_lab: 'Go to my lab',
            view_guide: 'View guide',
            view_gallery: 'View gallery',
            billing_details: 'Biing details',
            payment_confirmation_request: 'Payment Confirmation Request',
            payment_request_details: 'Payment request details',
            payment_request_text: 'We will notify you by email as soon as the payment is confirmed.',
            issue: 'Issue',
            not_issue: 'Do not issue',
            product_name: 'Plan name',
            price: 'Price',
            receipt: 'Cash receipt',
            payment_canceled: 'Payment Canceled',
            try_again: 'Please try again.',
            commercial_terms: 'See <a href="/commercial-terms" target="_blank">commercial terms</a>',
            creditcard: 'Credit Card',
            mobile: 'Mobile',
            price_KRW: '₩ {0}',
        },
        email_confirm: {
            email_confirm_title: 'Email verification is complete',
            go_to_lab: 'Go to my lab',
            not_valid_token: 'The token is not valid',
            resend_email: 'Please resend a verification email on your account page',
            go_to_account: 'Go to account page',
        }
    },
    ko: {
        welcome: {
            register: '회원가입',
            login: '로그인',
            logout: '로그아웃',
            guide: '가이드',
            support: '문의하기',
            plans: '플랜',
            policy: '이용약관',
            privacy: '개인정보처리방침',
            commercial_terms: '상업적 이용약관',
            notice: '공지사항',
        },
        account_modal: {
            account: '계정',
            report_an_issue: '문의/신고하기',
            my_requests: '나의 요청사항',
            user_guide: '유저 가이드',
            what_s_new_in_bt: "새로운 기능 및 개선사항",
            notice: "공지사항",
            sign_out: '로그아웃',
            to: '{0} 까지',
            admin: '관리자',
            trial: '프리미엄(시범사용)',
            expired: '이용권 만료',
            lifetime: '프리미엄(평생)',
            premium: '프리미엄',
            basic: '일반',
            event: '프리미엄(이벤트)',
            subscribe: '프리미엄 구독',
        },
        change_name: {
            change_name: '이름 변경하기',
            firstname: '이름',
            lastname: '성',
            try_again: '다시 시도해주세요.',
            close: '닫기',
            confirm: '확인',
        },
        change_password: {
            change_password: '비밀번호 변경하기',
            password: '비밀번호',
            password_re: '비밀번호 재입력',
            close: '닫기',
            confirm: '확인',
            try_again: '다시 시도해주세요.'
        },
        change_profile: {
            change_profile: '프로필 사진 변경하기',
            change_photo: '사진 변경',
            remove_photo: '사진 삭제',
            upload_photo: '사진 업로드',
            close: '닫기',
        },
        change_email: {
            change_email: '이메일 변경하기',
            resend_email: '이메일 다시 보내기',
            confirm_email_text: '이메일 인증 전에는 비밀번호 분실시 재설정을 할 수 없습니다. 인증 후에는 이메일 변경을 할 수 없습니다.',
            success: '이메일이 성공적으로 재전송되었습니다',
            success_text: '메일함을 확인해주세요.'
        },
        header: {
            gallery: '갤러리',
            lab: 'LAB',
            document_clip: '도큐먼트 클립',
            account: '계정',
            reviews: '리뷰 모아 보기',
            my_projects: '내 프로젝트',
            my_requests: '내 요청사항',
        },
        account: {
            profile: '프로필',
            membership: '멤버십 정보',
            plan_details: '플랜 상세 정보',
            settings: '설정',
            name: '이름',
            password: '비밀번호',
            start_date: '랩 개설 일자',
            language: '언어',
            manage_profile_photo: '프로필 사진 설정',
            change_name: '이름 변경',
            change_password: '비밀번호 변경',
            change: '변경',
            billing_details: '결제 상세 정보',
            premium: '프리미엄',
            monthly: '매월',
            won: '원',
            next_payment_date: '다음 결제일',
            cancel_premium: '프리미엄 해지',
            type: '결제유형',
            date: '결제일',
            product_name: '상품명',
            payment_method: '결제방법',
            payment_amount: '결제금액',
            payment_status: '결제상태',
            requested: '결제요청',
            completed: '결제완료',
            failed: '결제실패',
            canceled: '결제취소',
            refunded: '환불',
            cashwait: '결제대기',
            back_to_lab: '랩',
            update_payment_info: '결제 정보 업데이트',
            alert_update_payment_info: '결제 정보를 업데이트해주세요!',
            alert_update_payment_error: '결제 정보 업데이트 중 에러가 발생했습니다.',
            current_payment_methods: '현재 결제 수단',
            alert_update_payment_1: '결제 정보를 업데이트 하시려면 아래 결제 수단을 선택해주세요.',
            alert_update_payment_2: '팝업창이 뜨지 않는 경우 브라우저에서 팝업을 허용해주세요.',
        },
        login: {
            username: '사용자명',
            password: '비밀번호',
            remember_me: '기억하기',
            email: '이메일',
            login: '로그인',
            register: '가입하기',
            forgot_password: '비밀번호 찾기',
            password_reset: '패스워드 리셋하기',
            password_reset_subtitle: '패스워드 리셋을 위한 링크를 보내드립니다.',
            forgot_email: '이메일을 잊어버리셨나요?',
            back_to_login: '로그인 창으로 돌아가기',
            check_mailbox: '메일함을 확인해주세요',
            check_mailbox_subtitle: "{0}로 이메일을 보냈습니다. 이메일이 보이지 않으시면 스팸함 등 다른 폴더를 확인해주세요.",
            forgot_email_subtitle: '사용하시는 모든 이메일에서 "BiblioTrees"로 검색해 저희가 보낸 메일이 뜨는지 확인해보세요. 찾기 어려우시다면, 아래 문의하기를 눌러주세요.',
            contact: '문의하기',
        },
        register: {
            username: '회원 ID',
            firstname: '이름',
            lastname: '성',
            email: '이메일',
            password: '비밀번호',
            password_re: '비밀번호 확인',
            try_again: '다시 시도하세요',
            required: '이 항목은 필수입니다',
            login: '로그인',
            register: '가입하기',
            home: '랩',
            alert: '확인 메일을 보냈습니다. 메일함을 확인해주세요',
            go_home: '홈으로 돌아가기',
            username_not_valid: '사용자명은 6-30자로 문자와 숫자, 마침표를 사용할 수 있습니다',
            username_not_available: '이 사용자명은 사용할 수 없습니다',
            password_not_valid: '비밀번호는 8-30자로 문자, 숫자를 각각 한 문자 이상 포함해야 합니다',
            password_not_same: '비밀번호가 일치하지 않습니다',
            trial_30: '30일 프리미엄 무료 사용을 시작하세요!',
            start_trial: '프리미엄 무료 사용 시작하기',
            agree_description: '아래 "다음" 버튼을 누르시면 저희의 <a href="/policy" target="_blank">이용약관</a>과 <a href="/privacy" target="_blank">개인정보처리방침</a>에 동의하는 것으로 봅니다.',
            trial_text: '가입 후 1달간 프리미엄을 무료로 사용할 수 있습니다.',
            no_card: '카드 정보가 필요하지 않습니다',
        },
        signup: {
            register: '계정 등록',
            register_text: '환영합니다!',
            plan_selection: '이용권 선택',
            plan_selection_text: '이용권을 구독하세요',
            payment: '결제',
        },
        lab: {
            document: '도큐먼트',
            start_project: '프로젝트 만들기',
            activate_projects: '프로젝트 활성화',
            working_project: '진행 중인 프로젝트',
            complete_project: '완료한 프로젝트',
            holding_project: '보류한 프로젝트',
            preparing_project: '예정된 프로젝트',
            read_only_project: '읽기 전용 프로젝트',
            working: '작업 중',
            complete: '완료',
            holding: '보류',
            preparing: '예정',
            lab: '랩',
            document_clip: '도큐먼트 클립',
            projects: '내 프로젝트',
            my_reviews: '내 리뷰',
            watching_projects: '열람 프로젝트',
            library: '라이브러리',
            status: '상태',
            title: '제목',
            note_words: '노트 단어 수',
            note_modified: '노트 수정한 날짜',
            created: '생성한 날짜',
            completed: '완료한 날짜',
            visited: '방문한 날짜',
            start: '시작일',
            close: '종료일',
            words: '단어',
            modified: '변경일',
            empty_subtitle: "여기는 당신의 연구공간 '랩'입니다",
            empty_title: '새로운 프로젝트를 만들어보세요',
            project_info_1: '프로젝트는 도큐먼트를 모으고 관리하는 단위입니다.',
            project_info_2: '보고서, 논문 작성 등을 위해 회원님의 관심주제별로 프로젝트를 만들 수 있습니다.',
            open_soon: '곧 오픈됩니다!',
        },
        document_clip: {
            copy_move_to_projects: '프로젝트로 복사/이동하기',
            remove_from_document_clip: '도큐먼트 클립에서 제거하기',
        },
        reviews: {
            my_reviews: '내 리뷰',
            type: '유형',
            authors: '저자',
            year: '연도',
            title: '제목',
            modified: '수정된 날짜',
            document_details: '도큐먼트 상세',
            close: '닫기',
            project: '프로젝트',
            empty_title: '📝 이곳은 리뷰 페이지입니다.',
            empty_subtitle_1: '여기에서 각 프로젝트에 추가한 도큐먼트 리뷰들을 모아볼 수 있습니다.',
            empty_subtitle_2: '프로젝트 도큐먼트에 리뷰를 작성해보세요!'
        },
        create_project: {
            start_project: '새 프로젝트 시작하기',
            title: '제목',
            description: '설명',
            view_mode: '보기 모드',
            tree: '트리형',
            note: '노트형',
            cancel: '취소',
            start_later: '나중에 시작하기',
            start_now: '지금 시작하기',
            required: '제목은 1글자 이상이어야 합니다',
            available: '이 제목은 이미 사용 중입니다',
        },
        update_project: {
            update_project: '프로젝트 수정',
            title: '제목',
            description: '설명',
            status: '상태',
            working: '진행 중',
            complete: '완료',
            holding: '보류',
            preparing: '예정',
            view_mode: '보기 모드',
            tree: '트리형',
            note: '노트형',
            upload_photo: '사진 설정',
            change_photo: '사진 변경',
            remove_photo: '사진 삭제',
            delete_project: '프로젝트 삭제',
            required: '제목은 1글자 이상이어야 합니다',
            available: '이 제목은 이미 사용 중입니다',
            close: '취소',
            save: '저장',
            delete_project_description: '"{0}" 프로젝트를 삭제하시겠습니까? 삭제한 프로젝트는 복구할 수 없습니다.'
        },
        project: {
            note: '노트',
            tree: '트리',
            update_project: '프로젝트 정보 수정',
            reload: '트리 새로고침',
            show_suggestions: '제안 보기',
            close_suggestions: '제안 닫기',
            project: '프로젝트',
            in_project: '프로젝트 문서',
            not_in_project: '프로젝트에 없는 문서',
            refer: '참고',
            translate: '번역',
            revise: '개정',
            contents: '부분',
            read_only: '읽기 전용',
        },
        proj_note: {
            not_loaded: '노트 로드에 실패했습니다.',
            not_loaded_description: '노트를 불러오는 동안 오류가 발생했습니다. 다시 로드해주세요.',
            draft_not_saved: '드래프트를 저장하지 못했습니다.',
            draft_not_saved_description: '드래프트를 동기화하는 동안 오류가 발생했습니다. 다시 로드해주세요.',
            not_storable: '저장용량이 초과되었습니다. 추가된 내용은 저장되지 않습니다.',
            reload: '다시 로드하기',
            note_not_saved: '노트를 저장하지 못했습니다.',
            note_not_saved_description: '노트를 동기화하는 동안 오류가 발생했습니다. 다시 로드해주세요.',
            note_crashed: '저장 중 노트 내용이 충돌했습니다.',
            note_crashed_description: '저장 중 노트 내용이 충돌했습니다. 내용을 확인해주세요.',
            confirm: '확인',
            cancel_note: '노트 저장을 취소하시겠습니까? 아래 내용으로 노트가 수정됩니다.',
            change_not_saved: '저장되지 않은 변경사항이 있습니다',
            all_changes_saved: '모든 내용이 저장되었습니다',
            draft_error: '드래프트 저장 에러',
            save_error: '노트 저장 에러',
            saving_draft: '드래프트 저장 중...',
            draft_is_saved: '드래프트가 저장되었습니다',
            last_modified: '마지막 저장 일시: ',
            storage: '저장 용량: ',
            save: '저장',
            cancel: '취소',
        },
        doc_list: {
            documents: '도큐먼트',
            add_documents: '새 도큐먼트 추가',
            in_project: '프로젝트 도큐먼트',
            in_tree: '트리 도큐먼트',
            in_suggestion: '제안',
            card_view: '카드 뷰',
            list_view: '리스트 뷰',
            open_all_reviews: '모든 리뷰 열기',
            close_all_reviews: '모든 리뷰 닫기',
            tags: '태그',
            edit_documents: '리스트 수정',
            remove_documents: '도큐먼트 제거',
            copy_move: '복사/이동',
            remove: '제거',
            done: '닫기',
            references: '참고문헌',
            review: '리뷰',
            add_documents: '도큐먼트 추가하기',
            empty_title: '아래 버튼을 눌러 도큐먼트를 추가해주세요.',
            empty_meta_1: "팝업창에 직접 정보를 입력하거나, 팝업창 상단의 '파일 업로드' 버튼을 통해 도큐먼트를 추가할 수 있습니다.",
            empty_meta_2: "좌측 상단의 '노트', '트리' 탭을 통해 프로젝트 노트와 트리를 확인하세요.",
        },
        add_documents: {
            add_documents: '도큐먼트 추가하기',
            add_references: '참고문헌 추가하기',
            add_documents_to_document_clip: '클립에 도큐먼트 추가하기',
            add_doc_successfully: '도큐먼트가 성공적으로 추가되었습니다.',
            add_ref_successfully: '참고문헌이 성공적으로 추가되었습니다.',
            reload: '입력 초기화',
            type: '유형',
            not_recorded: '미상',
            et_al: '그 외',
            more: '상세 입력창 열기',
            less: '상세 입력창 닫기',
            close: '닫기',
            add: '추가하기',
            see_document: '도큐먼트 보기',
            add_others: '다른 도큐먼트 추가하기',
            already: '이미 프로젝트 안에 추가되어 있습니다',
            improve: '도큐먼트 정보를 개선해주세요!',
            fill: '빈 칸을 채워주세요',
            fill_required: '필수 항목을 채워주세요.',
            confirm: '확인',
            error_fileform: '파일 형식에 문제가 있습니다. 파일 형식을 다시 확인하시고 업로드해주세요.',
            error_checking: '도큐먼트 확인 중 문제가 발생했습니다. 지속적으로 문제가 발생할 경우 문의를 남겨주세요.',
            error_inputting: '도큐먼트 입력 중 문제가 발생했습니다. 지속적으로 문제가 발생할 경우 문의를 남겨주세요.',
            error_preview: '도큐먼트 미리보기를 렌더링하는 중 문제가 발생했습니다. 지속적으로 문제가 발생할 경우 문의를 남겨주세요.',
            suggestions: '제안',
            search: '검색',
            manual: '직접 입력',
            upload: '파일 업로드',
        },
        import_files: {
            import_files: '파일 업로드하기',
            files: '파일',
            documents: '도큐먼트',
            duplicates: '중복 도큐먼트',
            prepare: '준비',
            check: '점검',
            upload: '업로드',
            stop: '취소',
            select_all: '모두 선택하기',
            document_list: '도큐먼트 목록',
            already_in_project: '이미 프로젝트에 포함됨',
            already_in_document: '이미 도큐먼트에 포함됨',
            already_in_clip: '이미 클립에 포함됨',
            improve: '도큐먼트 정보를 개선해주세요!',
            right_info: '정확한 정보를 알려주세요.',
            add_to_project: '프로젝트에 추가하기',
            add_to_document: '추가하기',
        },
        improve_doc_info: {
            right_information: '정확한 정보를 알려주세요!',
            existing_columns: '기존 정보',
            new_columns: '새로운 정보',
            compare_columns: '비교할 정보',
        },
        gallery: {
            all: '전체',
            theme: '테마',
            person: '인물',
            document: '저작',
            coming_soon: '이 카테고리는 곧 공개됩니다.',
            picture_not_prepared: '사진이 준비되지 않았습니다.',
            category: '카테고리',
            title: '제목',
            tags: '태그',
            like: '좋아요',
            my_like: '나의 좋아요',
        },
        mp: {
            reload: '트리 새로고침',
            masterpiece: '마스터피스',
            in_masterpiece: '마스터피스 문서',
            not_in_masterpiece: '마스터피스에 없는 문서'
        },
        mp_list: {
            documents: '도큐먼트',
            in_masterpiece: '마스터피스',
            in_tree: '트리',
            like_document: '좋아요',
            fork_document: '가져오기',
            google_scholar: 'Google Scholar',
        },
        fork_mp: {
            fork_masterpiece: '마스터피스 가져오기',
            title: '제목',
            description: '설명',
            view_mode: '보기 모드',
            tree: '트리형',
            note: '노트형',
            close: '닫기',
            fork: '가져오기',
            like: '좋아요',
            complete: '랩에 마스터피스가 추가되었습니다.',
            go_project: '프로젝트로 가기',
            required: '이 항목은 필수입니다',
            title_not_available: '이 제목은 사용할 수 없습니다',
        },
        fork_doc: {
            fork_document: '도큐먼트 가져오기',
            select_project: '프로젝트를 선택해주세요',
            close: '닫기',
            fork: '가져오기',
            complete: '프로젝트에 도큐먼트가 추가되었습니다.',
            go_project: '프로젝트로 가기',
            already: '이 도큐먼트는 이미 프로젝트에 추가되었습니다.',
        },
        sorting: {
            title_a: '제목: 알파벳 순',
            title_d: '제목: 알파벳 역순',
            date_a: '날짜: 최근 항목에서 이전 항목 순',
            date_d: '날짜: 이전 항목에서 최근 항목 순',
            created_date_a: '생성한 날짜: 최근 항목에서 이전 항목 순',
            created_date_d: '생성한 날짜: 이전 항목에서 최근 항목 순',
            visited_date_a: '방문한 날짜: 최근 항목에서 이전 항목 순',
            visited_date_d: '방문한 날짜: 이전 항목에서 최근 항목 순',
            modified_date_a: '수정한 날짜: 최근 항목에서 이전 항목 순',
            modified_date_d: '수정한 날짜: 이전 항목에서 최근 항목 순',
            author_a: '저자: 알파벳 순',
            author_d: '저자: 알파벳 역순',
            title: '제목',
            date: '날짜',
            created_date: '생성한 날짜',
            visited_date: '방문한 날짜',
            author: '저자',
        },
        doc_types: {
            book: '단행본',
            book_chapter: '단행본 챕터',
            journal: '학술지',
            journal_article: '학술지 논문',
            conference: '컨퍼런스',
            conference_paper: '컨퍼런스 발표문',
            thesis: '학위논문',
            thesis_chapter: '학위논문 챕터',
            gov_document: '정부보고서',
            gov_document_article: '정부보고서 일부',
            law: '법률',
            law_article: '법조항',
            statistics: '통계명',
            statistics_table: '통계표',
            newspaper: '신문',
            newspaper_article: '신문 기사',
            magazine: '잡지',
            magazine_article: '잡지 기사',
            music_album: '음악 앨범',
            music: '음악',
            film: '동영상',
            film_episode: '동영상 에피소드',
            map: '지도',
            etc: '기타',
        },
        doc_info: {
            index: '번호',
            title: '제목',
            authors: '저자',
            author: '저자',
            editor: '편집자',
            translator: '번역자',
            date: '출간날짜',
            abstract: '초록',
            publication: '출간물 이름',
            publisher: '발행처',
            references: '참고문헌',
            note: '리뷰',
            star: '중요',
            tag: '태그',
            doc_type: '도큐먼트 유형',
            list: '리스트',
            go_list: '리스트로 돌아가기',
            add: '추가',
            add_to: '이 프로젝트에 추가하기',
            remove: '제거',
            remove_from: '이 프로젝트에서 제거하기',
            pre: '이전',
            pre_doc: '이전 도큐먼트',
            next: '다음',
            next_doc: '다음 도큐먼트',
            report: '신고하기',
            my_review: '내 리뷰',
            add_review: '내 리뷰 추가하기',
            add_references: '참고문헌 추가하기',
            more: '상세정보 열기',
            less: '상세정보 닫기',
            related_resources: '관련 도큐먼트',
            contents: '목차',
            other_editions: '다른 출판본',
            original_text: '초판본',
            translations: '번역본',
            referred_by: '이 도큐먼트를 참고한 문헌',
            report_url: 'URL 신고하기',
            add_url: 'URL 추가하기',
            report_url_text: 'URL이 잘못되었나요? 신고해주시면 운영자 확인 후 올바른 것으로 반영됩니다.',
            add_url_text_1: '알려주신 URL은 운영자 확인 후 올바른 것으로 반영됩니다.',
            add_url_text_2: 'URL이 여러 개일 경우 엔터로 구분해주세요.',
        },
        input_form: {
            doc_type: '도큐먼트 유형',
            author: '저자',
            reporter: '리포터',
            creator: '창작자',
            director: '감독',
            maker: '제작자',
            authors: '저자',
            reporters: '리포터',
            directors: '창작자',
            makers: '제작자',
            date: '날짜',
            statistics_date: '발행날짜',
            address_date: '발표날짜',
            publishing_date: '출간날짜',
            conference_dates: '컨퍼런스 날짜',
            year: '연도',
            title: '제목',
            law_title: '법명',
            statistics_title: '통계명',
            issue_title: '이슈 제목',
            article_title: '아티클 제목',
            album_title: '앨범 제목',
            film_title: '동영상 제목',
            chapter_title: '챕터 제목',
            table_title: '통계표 제목',
            music_title: '음악 제목',
            episode_title: '에피소드 제목',
            subtitle: '제목',
            language: '언어',
            lang: '언어',
            contents: '목차',
            description: '설명',
            abstract: '초록',
            keyword: '키워드',
            keywords: '키워드',
            doi: 'DOI',
            chapter_doi: '챕터 DOI',
            article_doi: '아티클 DOI',
            paper_doi: '페이퍼 DOI',
            book_doi: '단행본 DOI',
            thesis_doi: '학위논문 DOI',
            document_doi: '도큐먼트 DOI',
            proceeding_doi: '프로시딩 DOI',
            publication_doi: '출간물 DOI',
            DOI: 'DOI',
            DOI_chapter: '챕터 DOI',
            DOI_article: '아티클 DOI',
            DOI_paper: '페이퍼 DOI',
            DOI_book: '단행본 DOI',
            DOI_thesis: '학위논문 DOI',
            DOI_document: '도큐먼트 DOI',
            DOI_proceeding: '프로시딩 DOI',
            DOI_publication: '출간물 DOI',
            url: 'URL',
            chapter_url: '챕터 URL',
            article_url: '아티클 URL',
            table_url: '표 URL',
            music_url: '음악 URL',
            episode_url: '에피소드 URL',
            map_url: '지도 URL',
            book_url: '단행본 URL',
            thesis_url: '학위논문 URL',
            report_url: '보고서 URL',
            law_url: '법 URL',
            statistics_url: '통계 URL',
            journal_url: '학술지 URL',
            conference_url: '컨퍼런스 URL',
            newspaper_url: '신문 URL',
            magazine_url: '잡지 URL',
            album_url: '앨범 URL',
            film_url: '동영상 URL',
            publication_url: '출간물 URL',
            URL: 'URL',
            URL_chapter: '챕터 URL',
            URL_article: '아티클 URL',
            URL_table: '표 URL',
            URL_music: '음악 URL',
            URL_episode: '에피소드 URL',
            URL_map: '지도 URL',
            URL_book: '단행본 URL',
            URL_thesis: '학위논문 URL',
            URL_report: '보고서 URL',
            URL_law: '법 URL',
            URL_statistics: '통계 URL',
            URL_journal: '학술지 URL',
            URL_conference: '컨퍼런스 URL',
            URL_newspaper: '신문 URL',
            URL_magazine: '잡지 URL',
            URL_album: '앨범 URL',
            URL_film: '동영상 URL',
            URL_publication: '출간물 URL',
            journal_name: '학술지 제목',
            conference_name: '컨퍼런스 제목',
            newspaper_name: '신문 제목',
            magazine_name: '잡지 제목',
            book_title: '단행본 제목',
            document_title: '도큐먼트 제목',
            map_title: '지도집 제목',
            publication_title: '출간물 제목',
            volume: '권',
            volume_issue: '권(호)',
            number: '번호',
            numberth: '번호',
            pages: '페이지',
            article_number: '아티클 번호',
            episode_number: '에피소드 번호',
            edition: '판',
            diplome_title: '학위',
            document_category: '도큐먼트 분류',
            version: '버전',
            provisional_confirmed: '잠정 / 확정',
            session: '세션',
            morning_afternoon: '조간 / 석간',
            map_size: '지도 크기',
            publisher: '발행처',
            university: '대학',
            institution: '기관',
            company: '회사',
            label: '레이블',
            production: '프로덕션',
            oclc: 'OCLC',
            OCLC: 'OCLC',
            isbn: 'ISBN',
            ISBN: 'ISBN',
            issn: 'ISSN',
            ISSN: 'ISSN',
            editor: '편집자',
            editors: '편집자',
            jury: '심사위원',
            juries: '심사위원',
            translator: '번역자',
            translators: '번역자',
            paper_ebook: 'eBook',
            department: '분과',
            law_category: '법 분류',
            online_paper: '온라인 발행',
            place: '장소',
            dvd_online: 'DVD / 온라인',
            note: '노트',
            other_idf: '다른 식별자',
            digital_paper: '디지털 발행',
            film_note: '동영상 노트',
        },
        issues: {
            id: '아이디',
            type: '유형',
            title: '제목',
            created: '생성일',
            status: '상태',
            detail: '상세정보',
            document: '도큐먼트',
            authentication: '내 계정',
            purchase: '청구/결제',
            error: '기술적 문제',
            etc: '기타',
            new: '등록',
            in_progress: '접수완료',
            reporter_action: '답글요청',
            solution_provided: '답변완료',
            closed: '종료',
            reported_on: '요청일:',
            commented_on: '답변일:',
            add_a_comment: '답글 달기',
            save: '저장',
            cancel: '취소',
            close: '닫기',
            go_back: '뒤로',
            in_progress_info: '이슈 해결에 필요한 추가 정보가 있습니다. 상세정보를 눌러 답글을 남겨주세요.',
            solution_provided_info: '답변이 완료되었습니다. 상세정보를 눌러 답글을 남기거나 요청을 종료해주세요.',
            check_my_issue: '내 이슈 검토하기',
            continue: '계속하기',
            issue_close: '요청종료',
            solved: '해결완료',
            close_request: '내 요청 종료하기',
            close_alert: '요청을 완전히 종료하시겠습니까? 종료 후에는 요청 상태를 복원할 수 없습니다.',
            report_issue: '문의/신고하기',
            what_kind: '어떤 유형의 문제입니까?',
            description: '설명',
            document_details: '도큐먼트 상세',
            related_documents: '연관된 도큐먼트',
            references: '참고문헌',
            other_issue: '다른 이슈',
            write_down: '이슈를 자세히 적어주세요.',
            success: '이슈가 성공적으로 등록되었습니다.',
            try_again: '다시 시도해주세요.',
            empty_title: '🙋 이곳은 이슈 페이지입니다.',
            empty_subtitle: 'BiblioTrees에 대한 질문이나 의견이 있으신가요?',
            send_feedback: '피드백 남기기',
            success_text: '관리자가 확인하는대로 답변드리겠습니다.',
        },
        lang: {
            id: '인도네시아어',
            ms: '말레이시아어',
            da: '덴마크어',
            de: '독일어',
            en: '영어',
            es: '스페인어',
            fr: '프랑스어',
            it: '이탈리아어',
            nl: '네덜란드어',
            pl: '폴란드어',
            pt: '포르투갈어',
            fi: '핀란드어',
            sv: '스웨덴어',
            vi: '베트남어',
            tr: '터키어',
            ru: '러시아어',
            ar: '아랍어',
            th: '타이어',
            ko: '한국어',
            zh: '중국어',
            ja: '일본어',
            xx: '언어 미상',
        },
        alert: {
            try_again: '다시 시도해주세요',
            required: '이 항목은 필수입니다',
            email_not_valid: '유효한 이메일 주소를 입력해주세요 (id@company.com)',
            email_not_available: '이 이메일 주소는 사용할 수 없습니다',
        },
        actions: {
            submit: '제출',
            save: '저장',
            retry: '다시 시도하기',
            next: '다음',
            confirm: '확인',
            cancel: '취소',
            delete: '삭제',
            close: '닫기',
            go_back_to_lab: '내 랩으로 돌아가기',
            skip: '나중에 선택하기',
            select_all: '모두 선택하기'
        },
        note: {
            not_saved: '저장되지 않은 변경사항이 있습니다',
            last_modified: '수정된 일시',
            storage: '용량',
            delete: '삭제',
            export: '추출',
            save: '저장',
            cancel: '취소',
            close: '닫기',
            continue: '계속하기',
            delete_review: '리뷰 삭제하기',
            delete_alert: '리뷰가 영구적으로 삭제됩니다.'
        },
        plans: {
            TRIAL_90_DAYS: '90일 시범사용',
            TRIAL_30_DAYS: '30일 시범사용',
            one_month_event: '1개월',
            event_2021: '2021 다시시작 이벤트',
            PLAN_1_YEAR: '1년 이용권',
            LIFETIME: '평생 이용권',
            EVENT_PLAN_1_YEAR: '[이벤트] 1년 이용권',
            PLAN_LIFETIME: '평생 이용권',
            EVENT_LIFETIME: '[이벤트] 평생 이용권',
            price_unit: '{0} 원',
            price_KRW: '{0} 원',
            price_USD: '{0} 달러',
            month: ' /월',
            billed_as: '{0} 원이 결제됩니다',
            payment_currency: '결제 통화',
            cash: '계좌이체',
            paypal: 'Paypal(한국 외 계정)',
            card: '카드',
            phone: '휴대폰',
            discount: '할인',
        },
        payment: {
            enter_payment_details: '결제 정보를 입력해주세요',
            start_free_trial: '프리미엄 무료 사용을 시작하시겠습니까?',
            payment_methods: '결제 방법',
            depositor_name: '입금자명',
            cash_receipt: '현금영수증',
            receipt_yes: '신청하기',
            receipt_no: '신청 안 함',
            KRW: '계좌이체 (한국 계정)',
            USD: 'Paypal (한국 외 계정만 가능)',
            phone: '핸드폰 번호',
            id: '주민등록번호',
            card: '현금영수증카드번호',
            no_card_required: '카드 정보가 필요하지 않습니다',
            payment_summary: '멤버십 요약',
            trial_30days: '30일 프리미엄 무료 사용',
            three_months: '3개월',
            twelve_months: '12개월',
            purchase: '이용권 구독 시작하기',
            agree_start: '동의하고 시작하기',
            complete_the_deposit: '입금을 완료해주세요',
            deposit_text: '아래 계좌로 {0} 원을 입금하시고, 확인 버튼을 눌러주세요.',
            account_number: '계좌번호',
            welcome: '🎉 환영합니다! 🎉',
            with_bt: 'BiblioTrees와 함께 즐겁고 편리한 연구를 시작하세요.',
            go_to_lab: '내 랩으로 이동하기',
            view_guide: '가이드 보기',
            view_gallery: '갤러리 둘러보기',
            billing_details: '결제 상세',
            payment_confirmation_request: '결제 확인 요청',
            payment_request_details: '결제 요청 상세',
            payment_request_text: '결제가 확인되는대로 회원님의 메일로 알려드리겠습니다.',
            issue: '발급',
            not_issue: '발급하지 않음',
            product_name: '이용권 이름',
            price: '가격',
            receipt: '현금영수증',
            payment_canceled: '결제가 취소되었습니다',
            try_again: '다시 시도해주시기 바랍니다.',
            commercial_terms: '자세한 사항은 <a href="/commercial-terms" target="_blank">상업적 이용약관</a>을 확인하세요.',
            creditcard: '카드',
            mobile: '휴대폰',
            price_KRW: '{0} 원',
        },
        email_confirm: {
            email_confirm_title: '이메일 인증이 완료되었습니다',
            go_to_lab: '내 랩으로 가기',
            not_valid_token: '토큰이 유효하지 않습니다',
            resend_email: '계정 페이지에서 인증 메일을 다시 전송해주세요.',
            go_to_account: '계정 페이지로 가기',
        }
    },
}

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages,
})

export default i18n


// WEBPACK FOOTER //
// ./src/config/i18n.js